import React from "react";
import { Navigate } from "react-router-dom";

export default function My5999CargoPage() {
  return <Navigate to="/mijn-5999cargo" replace />;
}